import React, { useState, useEffect } from 'react';
import Chat from './Chat';
import Admin from './Admin';

export default function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    if (typeof window !== 'undefined') {
      try {
        return sessionStorage.getItem('admin_authenticated') === 'true';
      } catch (e) {
        return false;
      }
    }
    return false;
  });

  const [wantsAdmin, setWantsAdmin] = useState(() => {
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search);
      if (params.get('tab') || params.get('id') || params.get('unanswered_id') || params.get('admin') === 'true') {
        return true;
      }
    }
    return false;
  });

  const [passwordInput, setPasswordInput] = useState('');
  const [passwordError, setPasswordError] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search);
      if (params.get('tab') || params.get('id') || params.get('unanswered_id') || params.get('admin') === 'true') {
        setWantsAdmin(true);
      }
    }
  }, []);

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (passwordInput === 'heisenberg') {
      try {
        sessionStorage.setItem('admin_authenticated', 'true');
      } catch (err) {}
      setIsAuthenticated(true);
      setPasswordError(false);
      setPasswordInput('');
    } else {
      setPasswordError(true);
    }
  };

  const handleCancelPrompt = () => {
    if (typeof window !== 'undefined') {
      window.history.replaceState({}, '', window.location.pathname);
    }
    setWantsAdmin(false);
    setPasswordInput('');
    setPasswordError(false);
  };

  const handleBackToChat = () => {
    if (typeof window !== 'undefined') {
      window.history.replaceState({}, '', window.location.pathname);
    }
    setWantsAdmin(false);
  };

  // If user navigated to admin (e.g. via deep-link or button)
  if (wantsAdmin) {
    // If not yet authenticated in this session, show the passcode prompt
    if (!isAuthenticated) {
      return (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: '#09090b',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          padding: '16px'
        }}>
          <div style={{
            backgroundColor: '#18181b',
            padding: '32px',
            borderRadius: '16px',
            border: '1px solid rgba(63, 63, 70, 0.5)',
            width: '100%',
            maxWidth: '360px',
            boxShadow: '0 20px 40px rgba(0,0,0,0.5)',
            color: '#fafafa'
          }}>
            <h3 style={{ margin: '0 0 8px 0', fontSize: '20px', fontWeight: '600' }}>Admin Authentication</h3>
            <p style={{ margin: '0 0 20px 0', fontSize: '13px', color: '#a1a1aa' }}>
              Please enter the admin passcode to access the console.
            </p>
            <form onSubmit={handlePasswordSubmit}>
              <input
                type="password"
                placeholder="Enter passcode..."
                value={passwordInput}
                onChange={(e) => {
                  setPasswordInput(e.target.value);
                  if (passwordError) setPasswordError(false);
                }}
                autoFocus
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  backgroundColor: 'rgba(9, 9, 11, 0.8)',
                  border: passwordError ? '1px solid #ef4444' : '1px solid rgba(63, 63, 70, 0.5)',
                  borderRadius: '8px',
                  color: '#fff',
                  fontSize: '16px',
                  outline: 'none',
                  marginBottom: passwordError ? '8px' : '20px',
                  boxSizing: 'border-box'
                }}
              />
              {passwordError && (
                <p style={{ color: '#ef4444', fontSize: '13px', margin: '0 0 16px 0' }}>
                  Incorrect passcode. Please try again.
                </p>
              )}
              <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                <button
                  type="button"
                  onClick={handleCancelPrompt}
                  style={{
                    padding: '10px 16px',
                    backgroundColor: 'transparent',
                    border: 'none',
                    color: '#a1a1aa',
                    cursor: 'pointer',
                    borderRadius: '8px',
                    fontSize: '14px',
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  style={{
                    padding: '10px 20px',
                    backgroundColor: '#8b5cf6',
                    border: 'none',
                    color: '#fff',
                    cursor: 'pointer',
                    borderRadius: '8px',
                    fontWeight: '500',
                    fontSize: '14px',
                  }}
                >
                  Unlock
                </button>
              </div>
            </form>
          </div>
        </div>
      );
    }

    return <Admin onBackToChat={handleBackToChat} />;
  }

  return (
    <Chat
      onShowAdmin={() => {
        setIsAuthenticated(true);
        setWantsAdmin(true);
      }}
    />
  );
}